export default class ProjectDetailTabs {
    static init() {
        const tabs = document.querySelector('.tabs')

        if (tabs) {
            new ProjectDetailTabs(tabs)
        }
    }

    constructor(block) {
        block.array.forEach(tab => {

            const tabItems = tab.querySelectorAll('ul.tabs-navigation')
            const tabContentWrapper = tab.children('ul.tabs-content')

            tabItems.addEventListener('click', function (event) {
                event.preventDefault()

                let selectedItem = event.target

                if (!selectedItem.classList.contains('selected')) {
                    let selectedTab = selectedItem.data.content

                    let selectedContent = tabContentWrapper.querySelector(`li[data-content="${selectedTab}"]`)

                    tabItems.querySelector('a.selected').classList.remove('selected')
                    selectedItem.classList.add('selected')

                    selectedContent.classList.add('selected').siblings('li').removeClass('selected')
                }
            })
        })
    }
}
